import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Icon, Label, Button } from 'semantic-ui-react';
import TimeAgo from 'timeago-react';
import formatter from 'utils/formatter';
import { displayTitle } from 'utils/billDisplay';
import { register } from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
import { useSwipeable } from 'react-swipeable';

export default function BillCard({ bill, onDelete }) {
  const [swiped, setSwiped] = useState(false);
  
  // Register the Spanish locale
  register('es', es);

  const pendingOrders = bill.orders.filter(order => !order.delivered_at);

  // Swipe handlers
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => setSwiped(true),
    onSwipedRight: () => setSwiped(false),
    trackMouse: true
  });

  let summary = (
    <span style={{ fontSize: '1.5em', marginRight: '5px' }}>
      Sin ordenes pendientes
    </span>
  );

  if (pendingOrders.length === 1) {
    summary = (
      <span style={{ fontSize: '1.5em', marginRight: '5px' }}>
        <span style={{ fontWeight: 'bold' }}>1</span> orden pendiente
      </span>
    );
  }
  
  if (pendingOrders.length > 1) {
    summary = (
      <span style={{ fontSize: '1.5em', marginRight: '5px' }}>
        <span style={{ fontWeight: 'bold' }}>{pendingOrders.length}</span> ordenes pendientes
      </span>
    );
  }

  if (bill.orders.length === 0) {
    summary = (
      <span style={{ fontSize: '1.5em', marginRight: '5px', marginTop: '0.5em' }}>
        Sin ordenes
      </span>
    );
  }

  const handleDeleteClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onDelete) {
      onDelete(bill.id);
    }
    setSwiped(false);
  };

  const containerStyle = {
    position: 'relative',
    overflow: 'hidden',
    marginBottom: '1.5em',
    borderRadius: '4px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)'
  };

  const deleteButtonStyle = {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '70px',
    backgroundColor: '#DB2828',
    transform: swiped ? 'translateX(0)' : 'translateX(100%)',
    transition: 'transform 0.3s ease-out',
    zIndex: 0,
    touchAction: 'manipulation' // Improves touch responsiveness
  };

  const cardStyle = {
    marginBottom: 0,
    transform: swiped ? 'translateX(-70px)' : 'translateX(0)',
    transition: 'transform 0.3s ease-out',
    boxShadow: 'none',
    border: 'none',
    backgroundColor: 'white',
    zIndex: 1,
    position: 'relative',
    width: '100%'
  };

  return (
    <div style={containerStyle} {...swipeHandlers}>
      <div 
        style={deleteButtonStyle}
        onClick={handleDeleteClick}
        role="button"
        aria-label="Delete bill"
      >
        <Icon name="trash" size="large" style={{ color: 'white' }} />
      </div>
      
      <Card
        fluid
        key={bill.id}
        as={Link}
        to={`/bills/${bill.id}`}
        style={cardStyle}
      >
        <Card.Content style={{ cursor: 'pointer', padding: '1em' }}>
          <Card.Header style={{ fontSize: '1.5em', marginBottom: '10px' }}>
            { displayTitle(bill) }
          </Card.Header>
          <Card.Description>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}> 
              <Icon name="clock outline" size='large' />
              <span style={{ fontSize: '1em' }}>
                Abierta
                {' '}
                <TimeAgo
                  datetime={bill.created_at}
                  locale="es"
                />
              </span>
            </div>
            
            { bill.orders.length > 0 &&
              <div style={{ margin: '1em 0', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <span style={{ fontSize: '2em', marginRight: '10px', fontWeight: 'bold' }}>
                  { formatter.currency(bill.total) }
                </span>
                <div>
                  { bill.paid_at ? (
                    <Label color="green">
                      PAGADA
                    </Label>
                  ) : (
                    <Label color="red">
                      SIN PAGAR
                    </Label>
                  )}
                </div>
              </div>
            }
            <div style={{ display: 'flex', alignItems: 'center', margin: '0.5em 0 0.5em 0' }}>
              { summary }
              { (pendingOrders.length === 0) && (bill.orders.length > 0) &&
                <Icon name="check" size="large" color="green" />
              }
            </div>
          </Card.Description>
        </Card.Content>
      </Card>
    </div>
  )
}